module["exports"] = [
  "M",
  "Mme",
  "Mlle",
  "Dr",
  "Prof"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/name/prefix.js
// module id = 837
// module chunks = 0